import { Card } from '@/components/ui/card';

interface StatCardProps {
  label: string;
  value: string | React.ReactNode;
  variant?: 'default' | 'destructive' | 'warning';
}

export function StatCard({ label, value, variant = 'default' }: StatCardProps) {
  const valueClassName = {
    default: 'text-2xl font-semibold',
    destructive: 'text-2xl font-semibold text-destructive',
    warning: 'text-2xl font-semibold text-orange-600'
  }[variant];

  return (
    <Card className="p-4">
      <div className="text-sm text-muted-foreground">{label}</div>
      <div className={valueClassName}>{value}</div>
    </Card>
  );
}
